import * as React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import Main from './domain/Main/Main';

import './assets/dist/tailwind.css';
import './assets/scss/style.scss';
import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
export interface IApp {}

export default function App(props: IApp) {
  return (
    <Router basename='/'>
      <Switch>
        <Route exact path='/' component={Main} />
      </Switch>
    </Router>
  );
}
